module.exports = __webpack_public_path__ + "static/media/  (122).dc24a52e.jpg";